import React from 'react';
import '../css/privacy-policy.css';

const PrivacyPolicy = () => {
  return (
    <div>
      <section
        className="page-title"
        style={{ backgroundImage: 'url(images/background/3.jpg)' }}
      >
        <div className="auto-container">
          <h1>Privacy Policy</h1>
          <div className="bread-crumb-outer"></div>
        </div>
      </section>

      <section className="privacy-section">
        <div className="privacy-container">
          <h2 className="privacy-title">Privacy Policy</h2>

          <div className="privacy-content">
            <p>
              This Privacy Policy (“Policy”) reveals the privacy practices for Etravo website (“www.etravo.in”). Etravo places the highest importance on protecting the privacy of its clients’ (“User”) personal information under applicable laws in India.
            </p>
            <p>
              Please read this Policy carefully. By accessing or using our website, the User acknowledges that they have read, understood, and agreed to be bound by this Policy and our website’s terms of use.
            </p>

            <h3>Personal Information – What We Collect</h3>
            <p>
              Etravo collects and uses applicable personal information of the User in order to provide services. This includes, but is not limited to: name, contact number, address, company name, and vehicle preference.
            </p>

            <h3>How We Use Your Information</h3>
            <p>
              Information may be collected via mobile/telephone/email/online form, and used for:
            </p>
            <ul>
              <li>Service delivery and booking management</li>
              <li>Internal analysis to improve services</li>
              <li>Identity verification and secure communications</li>
            </ul>
            <p>
              Only authorized employees and partners of Etravo can access this information under strict confidentiality protocols.
            </p>

            <h3>Third-Party Transfers</h3>
            <p>Etravo does not share personal data except:</p>
            <ul>
              <li>With user permission</li>
              <li>With partners under strict confidentiality (via NDA)</li>
              <li>As required by law or legal processes</li>
              <li>During a merger/acquisition/business transfer</li>
              <li>To protect rights, safety, or property in good faith</li>
            </ul>

            <h3>Cookies</h3>
            <p>
              A cookie is a small file stored on a User’s device to save preferences and track site activity. Etravo uses cookies to improve user experience and may use third-party cookies for ad services.
            </p>
            <p>
              You can disable cookies in your browser settings, but some site features may not function properly.
            </p>

            <h3>Security</h3>
            <p>
              User data is stored on secure servers with limited access. While we follow industry standards, transmission of data over the internet is never 100% secure.
            </p>
            <p>
              Etravo is not responsible for unauthorized access or breaches by third parties.
            </p>

            <h3>Links to Other Sites</h3>
            <p>
              This website may contain links to other websites. Etravo is not responsible for the privacy practices of those sites. Users are encouraged to review their privacy policies separately.
            </p>

            <h3>Modifying Your Information</h3>
            <p>
              Users are encouraged to keep their information current. While Etravo keeps transaction records, certain data cannot be deleted due to recordkeeping policies.
            </p>

            <h3>Changes to This Policy</h3>
            <p>
              Etravo reserves the right to update this Policy at any time. Changes become effective immediately upon being posted on the site. Continued use of the website indicates acceptance of the revised terms.
            </p>

            <h3>Contact Etravo</h3>
            <p>
              For questions or suggestions regarding this policy, please contact Etravo.
            </p>
          </div>

          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>For any queries regarding our privacy policy, feel free to reach out:</p>
            <ul>
              <li><b>Phone:</b> <a href="tel:+919356411908">+91 9356411908</a></li>
              <li><b>Email:</b> <a href="mailto:booking@etravo.in">booking@etravo.in</a></li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
